import * as React from 'react';
import ProductService from 'src/services/productInformation/ProductInformationService';
import UserModel from 'src/model/user.model';
import Modal from 'src/components/common/Modal';
import './ProductInformationForm.scss';

interface IProductInformationFormProps {
  isLoggedIn: boolean;
  userData: UserModel;
  t?: any;
}

interface IProductInformationFormState {
  brand: any;
  model: any;
  partNumber: any;
  submitted: boolean;
  loading: boolean;
  phoneNumber: string;
  email: string;
}

class ProductInformationForm extends React.Component<
  IProductInformationFormProps,
  IProductInformationFormState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      brand: null,
      model: null,
      partNumber: null,
      submitted: false,
      loading: false,
      phoneNumber: null,
      email: ''
    };
  }

  public PhoneNumberRegEx = new RegExp('^$|(\\+[0-9]{1,3})?[0-9]{10}$');
  public emailRegEx = new RegExp('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$');
  public invalidPhoneNumber = false;
  public invalidEmail = false;

  public feedBackErrors: any = FeedBackFormErrors();

  private handlePartNumberChange = (event: any) => {
    const { value } = event.target;
    if (!value) {
      this.feedBackErrors.partNumberRequiredError = false;
      this.setState({ partNumber: null });
      return;
    }
    this.feedBackErrors.partNumberRequiredError = false;
    this.setState({ partNumber: value });
  };

  private handleBrandChange = (event: any) => {
    const { value } = event.target;
    if (!value) {
      this.feedBackErrors.brandRequiredError = false;
      this.setState({ brand: null });
      return;
    }
    this.feedBackErrors.brandRequiredError = false;
    this.setState({ brand: value });
  };

  private handleModelChange = (event: any) => {
    const { value } = event.target;
    this.setState({ model: value });
  };

  public ValidateForm = () => {
    this.feedBackErrors = FeedBackFormErrors();
    this.feedBackErrors.partNumberRequiredError = !this.state.partNumber
      ? true
      : false;
    this.feedBackErrors.brandRequiredError = !this.state.brand ? true : false;
    this.feedBackErrors.phoneNumberRequiredError = !this.state.phoneNumber
      ? true
      : false;
    this.feedBackErrors.emailRequiredError = !this.state.email ? true : false;
  };

  private formSubmit = (event: any) => {
    this.ValidateForm();
    if (
      this.feedBackErrors.isFieldsRequiredError() ||
      this.invalidEmail ||
      this.invalidPhoneNumber
    ) {
      this.setState({ loading: false });
      return;
    }
    ProductService.sendProductInformation(
      this.state.brand,
      this.state.model,
      this.state.partNumber,
      this.state.phoneNumber,
      this.state.email
    ).then((res: any) => {
      this.setState({
        submitted: true,
        brand: null,
        model: null,
        partNumber: null,
        loading: false,
        phoneNumber: null,
        email: ''
      });
    });
    // .catch((err: any) => {

    // })
  };

  private closeModal = () => {
    this.setState({
      submitted: false,
      partNumber: null,
      model: null,
      brand: null
    });
  };

  private handlePhoneNumberChange = (event: any) => {
    let { value } = event.target;
    if (!value) {
      this.invalidPhoneNumber = false;
      this.setState({ phoneNumber: null });
      return;
    }
    this.feedBackErrors.phoneNumberRequiredError = false;
    value = value.trim();
    !this.PhoneNumberRegEx.test(value) || value?.length > 20
      ? (this.invalidPhoneNumber = true)
      : (this.invalidPhoneNumber = false);
    this.setState({ phoneNumber: value });
  };

  private handleEmailChange = (event: any) => {
    let { value } = event.target;
    if (!value) {
      this.invalidEmail = false;
      this.setState({ email: '' });
      return;
    }
    this.feedBackErrors.emailRequiredError = false;
    value = value.trim();
    this.emailRegEx.test(value)
      ? (this.invalidEmail = false)
      : (this.invalidEmail = true);
    this.setState({ email: value });
  };

  public renderForm() {
    const { t } = this.props;
    return (
      <div className="rp-information-form-section">
        <div className="row">
          <div className="col-sm-5 product-form-desc-section">
            <h3 className="rp-information-form-header">
              {t('productForm.didNotFindProduct')}
            </h3>
            <p className="rp-information-form-text">
              {t('productForm.pleaseProvideProductDetails')}
            </p>
          </div>
          <div className="col-sm-5">
            <p className="rp-information-form--content-form-label">
              {t('productForm.productInfo')}
            </p>
            <input aria-label="What part are you looking for?"
              placeholder={t('productForm.whatlookingFor')}
              required={true}
              className={
                this.feedBackErrors?.partNumberRequiredError
                  ? 'rp-information-form--content-form-input rp-invalid-form-input-field'
                  : 'rp-information-form--content-form-input'
              }
              value={this.state.partNumber || ''}
              onChange={this.handlePartNumberChange}
            />
            {this.feedBackErrors?.partNumberRequiredError ? (
              <React.Fragment>
                <div className="rp-input-error">
                  {t('productForm.partNotEmpty')}
                </div>
              </React.Fragment>
            ) : (
              ''
            )}
            <div className="row no-gutters">
              <div className="col-sm-6 rp-information-form-brand-input">
                <input
                  placeholder={t('productForm.brandName')}
                  required={true}
                  className={
                    this.feedBackErrors.brandRequiredError
                      ? 'rp-information-form--content-form-input rp-brand-name-input rp-invalid-form-input-field'
                      : 'rp-information-form--content-form-input rp-brand-name-input'
                  }
                  value={this.state.brand || ''}
                  onChange={this.handleBrandChange}
                />
                {this.feedBackErrors.brandRequiredError ? (
                  <React.Fragment>
                    <div className="rp-input-error">
                      {t('productForm.brandNotEmpty')}
                    </div>
                  </React.Fragment>
                ) : (
                  ''
                )}
              </div>
              <div className="col-sm-6 rp-information-form-model-input">
                <input
                  placeholder={t('partClaim.modelNumber')}
                  className="rp-information-form--content-form-input"
                  value={this.state.model || ''}
                  onChange={this.handleModelChange}
                />
              </div>
            </div>
            {/* email and phone number fieds */}
            <div className="row no-gutters">
              <div className="col-sm-6 rp-information-form-brand-input">
                <input
                  placeholder={t('feedbackForm.phoneNumber')} // {t('productForm.brandName')}
                  required={true}
                  className={
                    this.feedBackErrors?.phoneNumberRequiredError ||
                    this.invalidPhoneNumber
                      ? 'rp-information-form--content-form-input rp-brand-name-input rp-invalid-form-input-field'
                      : 'rp-information-form--content-form-input rp-brand-name-input'
                  }
                  value={this.state.phoneNumber || ''}
                  onChange={this.handlePhoneNumberChange}
                />
                {this.invalidPhoneNumber ? (
                  <div className="rp-input-error">
                    {t('feedbackForm.invalidPhoneNumberFormat')}
                  </div>
                ) : (
                  ''
                )}
                {this.feedBackErrors?.phoneNumberRequiredError ? (
                  <div className="rp-input-error">
                    {t('productForm.phoneNumberNotEmpty')}
                  </div>
                ) : (
                  ''
                )}
              </div>
              <div className="col-sm-6 rp-information-form-model-input">
                <input ria-label="Email Address"
                  placeholder={t('feedbackForm.email')} // {t('partClaim.modelNumber')}
                  className={
                    this.feedBackErrors?.emailRequiredError || this.invalidEmail
                      ? 'rp-information-form--content-form-input rp-invalid-form-input-field'
                      : 'rp-information-form--content-form-input'
                  }
                  value={this.state.email || ''}
                  onChange={this.handleEmailChange}
                />
                {this.invalidEmail ? (
                  <div className="rp-input-error">
                    {t('feedbackForm.invalidEmailFormat')}
                  </div>
                ) : (
                  ''
                )}
                {this.feedBackErrors?.emailRequiredError ? (
                  <div className="rp-input-error">
                    {t('productForm.emailNotEmpty')}
                  </div>
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
          <div className="col-sm-2 text-center rp-prod-form-btn">
            <button
              type="button"
              className="primary-button rp-information-form-submit-btn"
              onClick={this.formSubmit}
            >
              {t('common.submitActionTxt')}
            </button>
          </div>
        </div>
      </div>
    );
  }

  public renderThankYou() {
    const { t } = this.props;
    return (
      <div className="rp-product-form--content">
        <div className="rp-product-form--content-title">
          {t('productForm.thankYouGetBack')}
        </div>
        <button
          className="secondary-button rp-product-form--content-form-button"
          onClick={this.closeModal}
        >
          {(t('common.close') as string).toUpperCase()}
        </button>
      </div>
    );
  }

  public render() {
    return (
      <div>
        {this.props.isLoggedIn && (
          <div>
            {this.state.submitted ? (
              <Modal handleCloseModal={() => this.closeModal()}>
                {this.renderThankYou()}
              </Modal>
            ) : (
              this.renderForm()
            )}
          </div>
        )}
      </div>
    );
  }
}

export default ProductInformationForm;

function FeedBackFormErrors() {
  return {
    partNumberRequiredError: false,
    brandRequiredError: false,
    phoneNumberRequiredError: false,
    emailRequiredError: false,
    isFieldsRequiredError() {
      return (
        this.partNumberRequiredError ||
        this.brandRequiredError ||
        this.phoneNumberRequiredError ||
        this.emailRequiredError
      );
    }
  };
}
